
import React, { useContext, useState, Fragment, useEffect } from 'react';
import AppContext from "../../AppContext";
import  { Auth } from 'aws-amplify';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Dialog, Transition } from '@headlessui/react'
import { Bars3Icon, XMarkIcon, ArrowLeftOnRectangleIcon, UsersIcon, CpuChipIcon } from '@heroicons/react/24/outline'


// const classNames = (...classes) => {
//   return classes.filter(Boolean).join(' ')
// }


const MainMenu = (props) => {
  
  const { availableDashboards, transparentLogo, apiKey, menuTitle, setMenuTitle, user } = useContext(AppContext);

  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  
  const [mainMenuOpen, setMainMenuOpen] = useState(false)
  const [folderList, setFolderList] = useState([])
  const [dashWithoutFolder, setDashWithoutFolder] = useState([])

  useEffect(() => {
    let folders = [];
    availableDashboards.forEach((x) => {
      if(x?.folder && (folders.find((y) => y?.folder === x?.folder) === undefined || folders.find((y) => y?.folder === x?.folder) === null)){
        folders.push({folder: x?.folder})
      }
    })
    setFolderList(folders)

    setDashWithoutFolder(availableDashboards?.filter((y) => y?.folder === null || y?.folder === undefined || y?.folder === ""))

  }, [availableDashboards])

  useEffect(() => {
    if(Object?.keys(params)?.length === 0){
      setMenuTitle(location.pathname === '/user-management' ? 'User Management' : null)
    }
    //eslint-disable-next-line
  }, [params])

  const navigateAction = (route) => {
    setMainMenuOpen(false)
    navigate(route); 
  }

  const toggleLeftSide = () => {
    setMainMenuOpen(!mainMenuOpen)
  }
  
  // useEffect(() => {
  //   enabled &&
  //   setRealTime(realTime => !realTime)
  // }, [enabled])

  return <>
    {/* ************************************************************ */}
    {/* *******************MOBILE MENU****************************** */}
    {/* ************************************************************ */}
    <Transition.Root show={mainMenuOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={() => toggleLeftSide()}>
        <Transition.Child as={Fragment}
          enter="transition-opacity ease-linear duration-300" enterFrom="opacity-0" enterTo="opacity-100" 
          leave="transition-opacity ease-linear duration-300" leaveFrom="opacity-100" leaveTo="opacity-0"
        >
        <div className="fixed inset-0 bg-gray-900/80" />
        </Transition.Child>
          <div className="fixed inset-0 flex">
            <Transition.Child as={Fragment}
              enter="transition ease-in-out duration-300 transform" enterFrom="-translate-x-full" enterTo="translate-x-0" 
              leave="transition ease-in-out duration-300 transform" leaveFrom="translate-x-0" leaveTo="-translate-x-full"
            >
              <Dialog.Panel className="relative mr-16 flex w-full max-w-xs flex-1">
                <Transition.Child as={Fragment}
                  enter="ease-in-out duration-300" enterFrom="opacity-0" enterTo="opacity-100"
                  leave="ease-in-out duration-300" leaveFrom="opacity-100" leaveTo="opacity-0"
                >
                  <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                    <button type="button" className="-m-2.5 p-2.5" onClick={() => toggleLeftSide()}>
                      <span className="sr-only">Close sidebar</span>
                      <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
                    </button>
                  </div>
                </Transition.Child>

                {/* MOBILE MOBILE MOBILE, swap this element with another sidebar if you like */}
                <div className="flex grow flex-col gap-y-5 bg-othergray-50 px-6 pb-4">
                  <nav className="flex flex-1 flex-col overflow-y-auto hide-scrollbar mt-4">
                    <ul className="flex flex-1 flex-col gap-y-7"> 

                    {/* <li className="-mx-6 mt-auto">
            <a
              href="#"
              className="flex items-center gap-x-4 px-6 py-3 text-sm font-semibold leading-6 text-white hover:bg-indigo-700"
            >
              <img
                className="h-8 w-8 rounded-full bg-indigo-700"
                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                alt=""
                
              />
              <span className="sr-only">Your profile</span>
              <span aria-hidden="true">Tom Cook</span>
            </a>
          </li> */}

                        <li>
                            <h1 className="font-display font-bold text-2xl text-primary-800 mb-4">Dashboards</h1>
                            {
                              dashWithoutFolder?.length > 0 && dashWithoutFolder?.map((x) => {
                                return(
                                  <div key={x?.key} >
                                    <button 
                                      key={`${x.key} button`} 
                                      onClick={() => navigateAction(`dashboard/${x?.url || x?.key}`)} 
                                      className="flex text-left w-full rounded-md text-md font-semibold leading-6 py-2 px-2 text-othergray-700 hover:bg-plumbus-100 hover:text-primary-800"
                                    >
                                      {x?.text}
                                    </button>
                                  </div>
                                )
                              })
                            }
                            
                            {
                              folderList.length >= 1 && availableDashboards?.length > 0 &&
                              folderList?.map((x) => {
                                return(<Fragment key={x.folder}>
                                  <h2 className="font-display text-lg font-semibold text-primary-800 leading-6 py-1 px-2">{x?.folder}</h2>
                                  <div className="flex flex-1 flex-col" key={x?.folder} >
                                    {availableDashboards?.filter((y)=> y.folder === x?.folder)?.map((xx) => {
                                      return(
                                        <div 
                                          className="flex flex-row rounded-md p-2 text-sm font-semibold text-gray-700" 
                                          key={`${xx?.folder}, ${xx?.key}`}
                                        >
                                          <button 
                                            key={xx.key} 
                                            onClick={() => navigateAction(`dashboard/${xx?.url || xx?.key}`)} 
                                            className="flex text-left w-full gap-x-3 rounded-md px-2 text-sm font-semibold leading-6 text-othergray-700 hover:bg-plumbus-100 hover:text-primary-800"
                                          >
                                            {xx.text}
                                          </button>
                                        </div>
                                      )
                                    })}
                                  </div>
                                </Fragment>
                                )
                              }) 
                            }
                        </li>
                        
                        
                          <li >
                          {import.meta.env.VITE_SSO === "true" &&  <>
                            {/* <div 
                              className="flex flex-row rounded-md p-2 text-sm font-semibold text-gray-700" 
                            >
                              <button 
                                onClick={() => navigateAction(`q`)} 
                                className="flex text-left w-full gap-x-3 rounded-md px-2 text-sm font-semibold leading-6 text-othergray-700 hover:bg-plumbus-100 hover:text-primary-800"
                              >
                                <CpuChipIcon
                                className="h-6 w-6  text-othergray-700 group-hover:text-primary-800"
                                aria-hidden="true"
                              />
                                Open Amazon Q
                              </button>
                            </div> */}
                            
                            <a
                              href={'/q'}

                              className=" rounded-md text-othergray-700 text-lg group flex w-full py-2 px-2 gap-x-3 font-bold leading-6 hover:bg-plumbus-100 hover:text-primary-800"
                            >
                              <CpuChipIcon
                                className="h-6 w-6  text-othergray-700 group-hover:text-primary-800"
                                aria-hidden="true"
                              />
                            Open Amazon Q
                            </a>

                            </>
                        }

                          {!apiKey && user?.attributes?.nickname === "ADMIN" && 
                            <button
                              onClick={() => navigateAction('/user-management')}
                              className=" rounded-md text-othergray-700 text-lg group flex w-full py-2 px-2 gap-x-3 font-bold leading-6 hover:bg-plumbus-100 hover:text-primary-800"
                            >
                              <UsersIcon
                                className="h-6 w-6  text-othergray-700 group-hover:text-primary-800"
                                aria-hidden="true"
                              />
                            User Management
                            </button>
                        }
                            {!apiKey && <button
                              onClick={() => Auth.signOut()}
                              className=" rounded-md text-othergray-700 text-lg group flex w-full py-2 px-2 gap-x-3 font-bold leading-6 hover:bg-plumbus-100 hover:text-primary-800"
                            >
                              <ArrowLeftOnRectangleIcon
                                className="h-6 w-6  text-othergray-700 group-hover:text-primary-800"
                                aria-hidden="true"
                              />
                              Logout
                            </button>}
                          </li>
                    </ul>
                </nav>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>


    {/* ************************************************************ */}
    {/* *******************Header*********************************** */}
    {/* ************************************************************ style={{backgroundColor: primaryColor}} */}
    <div className="h-full flex flex-col">
      <div className="sticky top-0 z-40 flex h-16 justify-between items-center gap-x-4 border-b border-gray-200 px-4 shadow-sm sm:gap-x-6 pl-4 pr-6 shadow ring-1 ring-black ring-opacity-5 bg-primary-600" > 
        <div className="flex flex-row align-center gap-2">
        <button type="button" className="-m-2.5 p-2.5 text-othergray-50 hover:text-othergray-400" onClick={() => toggleLeftSide()}>
          <span className="sr-only">Open sidebar</span>
          <Bars3Icon className="h-8 w-8" aria-hidden="true" />
        </button>
        <div className="hidden sm:flex self-center h-6 w-px bg-gray-200" aria-hidden="true" />
        <div className="hidden sm:flex self-center flex-1 text-sm font-semibold leading-6 text-othergray-50 max-h-full overflow-hidden whitespace-nowrap text-ellipsis">{menuTitle}</div>
        </div>
        <div className="w-36 h-full" style={{ backgroundColor: transparentLogo ? undefined : 'white', backgroundImage:"url('/logo.png')", backgroundRepeat: 'no-repeat', backgroundSize: 'contain', backgroundPositionY: 'center'}}></div>
      </div>
    </div>

  </>
};

export default MainMenu;